module.exports = __webpack_public_path__ + "img/universe.4d5e5ebf.png";